import React, { createContext, useContext, useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

const BannerContext = createContext({ banners: [], loading: true });

export const useBanners = () => useContext(BannerContext);

export const BannerProvider = ({ children }) => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const snap = await getDocs(collection(db, 'banners'));
        const list = snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .filter(b => b.active !== false)
          .sort((a, b) => (a.order || 0) - (b.order || 0));
        setBanners(list);
      } catch (err) {
        console.error('배너 로드 실패:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBanners();
  }, []);

  return (
    <BannerContext.Provider value={{ banners, loading }}>
      {children}
    </BannerContext.Provider>
  );
};
